module.exports = __webpack_public_path__ + "static/img/k2.cd34d38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/k2.png
// module id = O1t7
// module chunks = 1